export default __webpack_public_path__ + "static/media/mid6.2eab26db.jpg";